// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  // When true, the mold-temperature chart uses the in-app simulator instead of
  // the real thermometer feed (localhost:5000).
  simulateMoldTemperature: false,
  azure: {
    client_id: 'd97cf199-400e-4cf2-bdf9-a12dee4bd381',
    authority:
      'https://login.microsoftonline.com/02170ef0-0911-470f-8d82-58095c2516ce',
    redirectUri: '/',
    consentScopes: [
      // 'user.read',
      // 'openid',
      // 'profile',
      // 'email',
      'd97cf199-400e-4cf2-bdf9-a12dee4bd381/.default',
    ],
  },
  graph: {
    profile: 'https://graph.microsoft.com/v1.0/me',
  },
  apiBase:
    'https://api-elite-dev-gaembcfzamazfyb5.westus2-01.azurewebsites.net',
  otherApis: {
    netsuite: 'https://api-netsuite.elite-manufacturing.com',
    netsuiteV2: 'https://api-netsuite-v2.elite-manufacturing.com',
    asana: 'https://api-asana.elite-manufacturing.com',
    apiBaseElite:
      'https://api-elite-dev-gaembcfzamazfyb5.westus2-01.azurewebsites.net',
    files: 'https://api-files.elite-manufacturing.com',
    boxApi:
      'https://transfer-elite-cqh9d0grefbfgqej.westus-01.azurewebsites.net',
    cobot: 'https://api-cobot.elite-manufacturing.com/api/cobot-ai',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in inspect-production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
